import { config } from "JS/Config";
import {
    getInitialValidityFromRules,
    ValidationRules,
    ValidationTypes,
} from "JS/Helpers";
import { ILogin, TokenResponse, User } from "JS/Models";
import { BaseService } from "../BaseService";
import { appConstants } from "JS/Helpers/Constants";

export class UsersService extends BaseService {
    login = (loginData: ILogin) => {
        return new Promise<User>((res, rej) => {
            this.ngCall<User[]>(
                "post",
                appConstants.ngEndpoints.login,
                {
                    memberId: loginData.userName,
                    password: loginData.password,
                    tenantId: "ltd",
                    clientId: 2,
                    platform: "web",
                    scope: "media_scope",
                },
                null,
            )
                .then((r) => {
                    res({
                        ...r.data.find((u) => u.primary),
                        memberId: loginData.userName,
                    });
                })
                .catch((e) => rej(e));
        });
    };

    createToken = () =>
        this.ngCall<TokenResponse>(
            "get",
            appConstants.ngEndpoints.accessToken,
            {
                params: {
                    tenantId: "ltd",
                    clientId: 2,
                    memberId: "6036220",
                    scope: "media_scope",
                    access_token: "",
                },
            },
            {
                headers: {
                    authorization: `Bearer ${config.ngAccesstoken}`,
                },
            },
        );

    refreshToken = () =>
        this.ngCall<TokenResponse>(
            "post",
            appConstants.ngEndpoints.refreshToken,
            {
                params: {
                    refreshToken: "",
                    tenantId: "ltd",
                    clientId: 2,
                    memberId: "6036220",
                    scope: "media",
                },
            },
            {
                headers: {
                    authorization: `Bearer ${config.ngAccesstoken}`,
                },
            },
        );

    disableJwtToken = () =>
        this.ngCall(
            "put",
            appConstants.ngEndpoints.disableJwtToken(config.user.memberId),
            {
                refreshToken: config.ngRefreshToken,
            },
        );
}

export const loginValidityRules: ValidationRules<keyof ILogin> = {
    userName: [
        { rule: ValidationTypes.REQUIRED, message: "User Name is required" },
        { rule: ValidationTypes.NUMBER, message: "User Name should be number" },
    ],
    password: [
        { rule: ValidationTypes.REQUIRED, message: "Password is required" },
    ],
};

export const dysValidityRules: ValidationRules<keyof ILogin> = {
    userName: [
        { rule: ValidationTypes.REQUIRED, message: "User Name is required" },
    ],
    password: [
        { rule: ValidationTypes.REQUIRED, message: "Password is required" },
    ],
};

export function validateLogin(login: ILogin) {
    const state = getInitialValidityFromRules(loginValidityRules, login);

    return state;
}

export function validateDYSLogin(login: ILogin) {
    const state = getInitialValidityFromRules(dysValidityRules, login);

    return state;
}
